<wa-dialog label="select staff members" open="true" lightDismiss=false withoutHeader=true withFooter="true">
  <div class="wa-stack">
    <h3 class="wa-heading-m">Add excluded time period for exam supervisions</h3>
    <p>I will <strong>not</strong> be available for exam supervisions during this time period:</p>
    <form [formGroup]="exclusionForm">
      <div class="wa-stack">
        <div class="wa-grid">
          <wa-date-input label="start date" hint="first date of unavailability" formControlName="begin"></wa-date-input>
          <wa-date-input label="end date (inclusive)" hint="last date of unavailability" formControlName="end"></wa-date-input>
        </div>
        <wa-input label="comment (optional)" type="text" formControlName="note"
                  placeholder="e.g., 'holiday' or 'conference'"
        hint="the comment is just meant for yourself"></wa-input>
      </div>
    </form>
  </div>
  <div slot="footer">
    <div class="wa-cluster">
    <wa-button variant="neutral" appearance="filled" (click)="cancel()">Cancel</wa-button>
    @if (isCreateDisabled()) {
      <wa-button
        variant="brand"
        [disabled]="true"
        (click)="create()">
        Save
      </wa-button>
    } @else {
      <wa-button
        variant="brand"
        (click)="create()">
        Save
      </wa-button>
    }
  </div>
  </div>
</wa-dialog>
